import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Image, Input } from "antd";

import Swal from "sweetalert2";

import inquiryApi from "../../../apis/Inquiry.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import { toastAlert } from "../../AlertComponent";

const InquiryManageEachAnswer = ({
	inquiryId,
	getInquiryBoard,
	imageList,
	setImageList,
	photoList,
	setPhotoList,
	answerValue,
	setAnswerValue,
}) => {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const inputRef = useRef(null);

	const handleAnswerValue = (e) => {
		let { name, value } = e.target;
		setAnswerValue({
			...answerValue,
			[name]: value,
		});
	};

	/**
	 * 프론트 내 업로드 버튼 클릭
	 */
	const onUploadImageClick = () => {
		if (imageList?.length >= 5) {
			toastAlert("이미지는 최대 5장까지 가능합니다.");
		} else {
			if (!inputRef.current) {
				return;
			}
			inputRef.current.click();
		}
	};

	/**
	 * 프론트 내 업로드 진행
	 * @param e
	 */
	const onUploadImage = (e) => {
		if (!e.target.files) {
			return;
		}
		const fileList = e.target.files;
		const urlList = [...imageList];
		const photoInfoList = [...photoList];
		for (let i = 0; i < fileList?.length; i++) {
			const fileUrl = URL?.createObjectURL(fileList[i]);
			urlList.push(fileUrl);
			photoInfoList.push({
				file: fileList[i],
				source: fileUrl,
				type: fileList[i]?.type,
			});
		}
		setImageList(urlList?.slice(0, 5));
		setPhotoList(photoInfoList?.slice(0, 5));
	};

	/**
	 * 이미지 삭제 (목록에서 제거 -> 작성/수정완료 클릭 시 적용)
	 * @param idx
	 */
	const onDeleteImage = (idx) => {
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 이미지를 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				let list = [...imageList];
				let photos = [...photoList];
				list.splice(idx, 1);
				photos.splice(idx, 1);
				setImageList(list);
				setPhotoList(photos);
			}
		});
	};

	/**
	 * 상담게시판 답변 삭제
	 * @returns {Promise<void>}
	 */
	const deleteInquiry = async () => {
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 답변 글을 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				setIsLoading(true);
				const param = {
					inquiryId: inquiryId,
					answerId: answerValue?.id,
					influencerId: user?.id,
					userId: user?.id,
				};
				const res = await inquiryApi.adminDeleteInquiry(param);
				if (res.code === 200) {
					Swal.fire({
						customClass: "alert-custom",
						text: "성공적으로 삭제되었습니다!",
						confirmButtonText: "확인",
					}).then(() => {
						getInquiryBoard();
						setIsLoading(false);
					});
				} else {
					Swal.fire({
						customClass: "alert-custom",
						text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
						confirmButtonText: "확인",
					}).then(() => {
						setIsLoading(false);
					});
				}
			}
		});
	};

	return (
		<div className={`inquiry-manage-each-component`}>
			<div className={`inquiry-manage-title-div`}>
				{answerValue?.id ? (
					<>
						<p>답변수정</p>
						<Button onClick={deleteInquiry} loading={isLoading}>
							삭제
						</Button>
					</>
				) : (
					<p>답변작성</p>
				)}
			</div>
			<div className={`inquiry-manage-answer`}>
				<Input
					type={`text`}
					disabled={isLoading}
					placeholder={`제목을 입력해 주세요.`}
					value={answerValue?.title}
					onChange={handleAnswerValue}
					name={`title`}
				/>
				<Input.TextArea
					type={`text`}
					disabled={isLoading}
					placeholder={`내용을 입력해 주세요.`}
					value={answerValue?.content}
					onChange={handleAnswerValue}
					name={`content`}
				/>
				<div className={`inquiry-manage-image-group`}>
					<button
						className={`inquiry-manage-image-button`}
						style={{ padding: 0 }}
						onClick={onUploadImageClick}
					>
						<input
							type="file"
							multiple="multiple"
							accept="image/*"
							style={{
								display: "none",
							}}
							ref={inputRef}
							onChange={onUploadImage}
						/>
						<img
							src={`/assets/images/channel/img-add.png`}
							// src={`/assets/images/channel/doctor.png`}
							onError={({ currentTarget }) => {
								currentTarget.onerror = null; // prevents looping
								// currentTarget.style.display = "none";
								currentTarget.src = `/assets/images/channel/img-add.png`;
							}}
							alt={`상품 이미지`}
						/>
					</button>
					<Image.PreviewGroup>
						<div className={`image-preview-group`}>
							{imageList?.map((src, idx) => (
								<div
									className={`image-div`}
									key={`image-community-images-key-${idx}`}
								>
									<Image
										preview={{
											mask: <></>,
										}}
										src={src}
										alt={`상담 글 이미지 ${idx}`}
									/>
									<img
										src={`/assets/images/channel/cancel.png`}
										alt={`이미지 삭제`}
										className={`image-delete-icon`}
										onClick={() => onDeleteImage(idx)}
									/>
								</div>
							))}
						</div>
					</Image.PreviewGroup>
				</div>
				<p>* 이미지는 최대 5장까지 가능합니다.</p>
			</div>
		</div>
	);
};
export default InquiryManageEachAnswer;
